import React from "react";
import { Backdrop } from "@mui/material";

type ModalProps = {
  isOpen: boolean
}

export default function ModalLoadingClock(
  { isOpen }: ModalProps
) {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isOpen || false}
    >
      <div className="container_loader">
        <div className="clock"></div>
        <p style={{ marginTop: "7rem" }}>Loading...</p>
      </div>
    </Backdrop>
  );
}
